export default __webpack_public_path__ + "static/media/whatsapp-card-icon.437dfa0c.svg";